export default "__VITE_ASSET__5$jkH3bg__ 640w, __VITE_ASSET__CwekI7Ye__ 1024w, __VITE_ASSET__DXbynV4F__ 1536w";